export default "__VITE_ASSET__2431cf56__"